// extracted by mini-css-extract-plugin
export default {"title":"Timer_title__d9oqM","button":"Timer_button__NwVw5","timeLeft":"Timer_timeLeft__Ck4Er","mainContainer":"Timer_mainContainer__eKacp"};